<template>
    <div class="changeLanguage">
        <img :src="imgList[currentLanguageName]" alt="" style="height: 1rem;">
        <div class="changeItemsBox">
            <div class="changeItems">
                <div v-for="(item, index) of list" :key="item.key" class="changeItem" @click="command(item)">
                    
                    <img :src="imgList[item.key]" alt="" style="height: 1rem;margin-right: 0.5rem;">
                    <div>
                        {{ item.name }}
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>


export default {
    name: 'changeLanguage',
    data() {
        return {
            currentLanguageName: localStorage.getItem('change-language') || 'zh',
            list: [
                { key: 'zh', name: '中文' }, // 中文
                { key: 'EN', name: 'English' } // 英语
            ],
            imgList: {
                zh: require('../../public/image/中国国旗.png'),
                EN: require('../../public/image/美国国旗.png')
            }
        }
    },
    methods: {
        command(value) {
            // console.log(value)
            this.$i18n.locale = value.key
            localStorage.setItem('change-language', value.key)
            location.reload() //强制刷新
        }
    }
}
</script>

<style lang="scss" scoped>
.changeLanguage {
    width: 3rem;
    height: 3rem;
    background-color: #fff;
    box-shadow: 0px 0px 15px 1px rgba(99, 98, 98, 0.5);
    border-radius: 50%;
    position: fixed;
    right: 2rem;
    bottom: 10rem;
    z-index: 99999999999999;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover .changeItemsBox {
        display: block;
    }

    .changeItemsBox {
       
        position: absolute;
        left: -8rem;
       
        overflow: hidden;
        display: none;
        padding-right: 2rem;
        // border: 1px solid red;

        .changeItems {
            background-color: #fff;
            border-radius: 1rem;
            overflow: hidden;
            .changeItem {
                padding: 1rem;
                display: flex;
                cursor: pointer;
                align-items: center;
                &:hover {
                    background-color: #f7f7f7;
                }
            }
        }


    }

}
</style>
